// Conversation Audit API. Kept apart from the sandbox chat client so changes
// to sandbox chat persistence do not ripple into the audit flyout.

export type SandboxAuditThreadSummary = {
  id: number;
  title: string;
  model: string;
  model_name: string | null;
  user_id: number;
  user_email: string | null;
  created_at: string;
  message_count: number;
};

export type SandboxAuditMessage = {
  id: number;
  role: string;
  content: string | null;
  error_code: string | null;
  created_at: string;
};

export type SandboxAuditThreadDetail = SandboxAuditThreadSummary & {
  messages: SandboxAuditMessage[];
};

export type SandboxAuditThreadsResponse = {
  page: number;
  page_size: number;
  total_count: number;
  conversations: SandboxAuditThreadSummary[];
};

export type SandboxAuditPerson = { id: number; email: string };
export type SandboxAuditTeam = { id: number; name: string };

export type SandboxAuditFilterOptions = {
  people: SandboxAuditPerson[];
  teams: SandboxAuditTeam[];
};

async function parseJson<T>(response: Response): Promise<T> {
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error((data as { error?: string }).error || "Request failed");
  }
  return data as T;
}

export async function listSandboxAuditThreads(params: URLSearchParams): Promise<SandboxAuditThreadsResponse> {
  const response = await fetch(`/api/v1/sandbox_audit/conversations?${params.toString()}`);
  return parseJson<SandboxAuditThreadsResponse>(response);
}

export async function showSandboxAuditThread(id: number): Promise<SandboxAuditThreadDetail> {
  const response = await fetch(`/api/v1/sandbox_audit/conversations/${id}`);
  return parseJson<SandboxAuditThreadDetail>(response);
}

export async function getSandboxAuditFilterOptions(): Promise<SandboxAuditFilterOptions> {
  const response = await fetch("/api/v1/sandbox_audit/filter_options");
  return parseJson<SandboxAuditFilterOptions>(response);
}
